// extracted by mini-css-extract-plugin
export default {"texteditor":"TextEditor_texteditor__69tC5"};